import React, { useState } from 'react'
import { dateToTimestamp } from '../utils/date';
import DatePicker, { registerLocale } from 'react-datepicker'
import enGb from "date-fns/locale/en-GB"
import "react-datepicker/dist/react-datepicker.css";
import '../../assets/styles/datepicker.scss'

function DatePickerCustom({objKey, className, value, onChange, time=false}) {
  // set to local britain because monday is first day of week
  registerLocale('en-gb', enGb)

  const [dateState, setDateState] = useState('')

  const updateValue = (date, evt) =>  {
    if(evt) setDateState(date)
    if(!time) onChange(dateToTimestamp(date), objKey)

    if(time && !evt){
      if(dateState){
        const dateWithoutTime = new Date(dateState.getFullYear(), dateState.getMonth(), dateState.getDate())

        const hours = date.getHours()
        const minutes = date.getMinutes()
        const seconds = date.getSeconds()

        const newDate = new Date(
          dateWithoutTime.getFullYear(),
          dateWithoutTime.getMonth(),
          dateWithoutTime.getDate(),
          hours,
          minutes,
          seconds
        )

        onChange(dateToTimestamp(newDate), objKey)
      } else {
        onChange(dateToTimestamp(date), objKey)
      }
    } 
  }  

  const customDateHeader = (props) => {
    const {date, changeYear, changeMonth } = props

    return (
      <div className="date-header-section">
        <select
          value={date.getFullYear()}
          onChange={({ target: { value } }) => changeYear(Number(value))}
        >
          {Array.from({ length: 100 }, (_, i) => 2025 - i).map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <select
          value={date.getMonth()}
          onChange={({ target: { value } }) => changeMonth(Number(value))}
        >
          {Array.from({ length: 12 }, (_, i) => i).map((month) => (
            <option key={month} value={month}>
              {new Date(0, month).toLocaleString("default", { month: "long" })}
            </option>
          ))}
        </select>
      </div>
    )
  }

  return (
    <DatePicker 
      className={className}
      dateFormat={time ? "dd/MM/yyy HH:mm" : "dd/MM/yyy"} 
      selected={value ? new Date(value) : ''}
      onChange={(date, evt) => updateValue(date, evt)}
      showTimeSelect={time}
      timeFormat="HH:mm"
      timeIntervals={15}
      locale="en-gb"
      renderCustomHeader={(props) => customDateHeader(props)}
    />
  )
}

export default DatePickerCustom